export const CategoriasRutaActionTypes = {
  API_RESPONSE_SUCCESS: '@@categorias-ruta/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@categorias-ruta/API_RESPONSE_ERROR',

  GET_CATEGORIA_RUTA: '@@categorias-ruta/GET_CATEGORIA_RUTA',
  LIST_CATEGORIAS_RUTA: '@@categorias-ruta/LIST_CATEGORIAS_RUTA',
  ADD_CATEGORIA_RUTA: '@@categorias-ruta/ADD_CATEGORIA_RUTA',
  UPDATE_CATEGORIA_RUTA: '@@categorias-ruta/UPDATE_CATEGORIA_RUTA',
  DELETE_CATEGORIA_RUTA: '@@categorias-ruta/DELETE_CATEGORIA_RUTA',

  RESET: '@@categorias-ruta/RESET'
}
